import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/Footer.css'
import { useTranslation } from '../context/LanguageContext.jsx'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            <h3>Deverse</h3>
            <p>{t('footer.tagline')}</p>
          </div>
        </div>

        <div className="footer-section">
          <h4>{t('footer.servicesTitle')}</h4>
          <ul>
            <li>
              <a href="#services">{t('footer.footerWebPages')}</a>
            </li>
            <li>
              <a href="#services">{t('footer.footerMobileApps')}</a>
            </li>
            <li>
              <a href="#services">{t('footer.footerCustomSoftware')}</a>
            </li>
            <li>
              <a href="#services">{t('footer.footerQr')}</a>
            </li>
            <li>
              <a href="#services">{t('footer.footerRes')}</a>
            </li>
            <li>
              <a href="#services">{t('footer.footerPortfolio')}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.companyTitle')}</h4>
          <ul>
            <li>
              <a href="#about">{t('footer.aboutUs')}</a>
            </li>
            <li>
              <a href="#portfolio">{t('footer.ourProjects')}</a>
            </li>
            <li>
              <a href="#demo">{t('nav.demo')}</a>
            </li>
            <li>
              <a href="#contact">{t('footer.contact')}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.connectTitle')}</h4>
          <div className="social-links">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <span>LinkedIn</span>
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <span>GitHub</span>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <span>Twitter</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-legal">
          <p>
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
          <div className="legal-links">
            <Link to="/privacy-policy">{t('footer.privacy')}</Link>
            <Link to="/terms-of-service">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
